// store.js
import { create } from 'zustand';

export const useSystemOptionsStore = create((set) => ({
    systemOptions: {
        votacionActiva: 0,
        whatsapp: '',
        mailAyuda: '', // Nueva opción
    },
    
    updateSystemOptions: (newOptions) => {
        const transformedOptions = {
            votacionActiva: newOptions?.votacionActiva ?? 0,
            whatsapp: newOptions?.whatsapp ?? '',
            mailAyuda: newOptions?.mailAyuda ?? '',
        };
        
        set(() => ({ systemOptions: transformedOptions }));
    },
    
    setVotacionActiva: (estado) => set((state) => ({
        systemOptions: {
            ...state.systemOptions,
            votacionActiva: estado
        }
    })),
    
    setWhatsapp: (numero) => set((state) => ({
        systemOptions: {
            ...state.systemOptions,
            whatsapp: numero
        }
    })),
    
    setMailAyuda: (mail) => set((state) => ({
        systemOptions: {
            ...state.systemOptions,
            mailAyuda: mail
        }
    })),
    
    resetSystemOptions: () => set(() => ({ 
        systemOptions: {
            votacionActiva: 0,
            whatsapp: '',
            mailAyuda: '',
        }
    })),
}));